import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

export const sendTranscript = createAsyncThunk(
  'message/send-transcript',
  async ({ roomId, email }, { getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;

    if (!roomId) {
      return rejectWithValue({ message: 'Room ID is required.' });
    }

    try {
      const response = await fetch(
        `${ROOT_URL}/message/send-transcript/${roomId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ email }),
        },
      );

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        return rejectWithValue(
          result || { message: 'Failed to send transcript.' },
        );
      }

      return result;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || 'Failed to send transcript.',
      });
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  response: null,
  error: null,
};

const sendTranscriptSlice = createSlice({
  name: 'sendTranscript',
  initialState,
  reducers: {
    resetSendTranscriptState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendTranscript.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
        state.isError = false;
        state.error = null;
      })
      .addCase(sendTranscript.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.response = action.payload;
      })
      .addCase(sendTranscript.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.error = action.payload;
      });
  },
});

export const { resetSendTranscriptState } = sendTranscriptSlice.actions;
export default sendTranscriptSlice.reducer;
